import { AiOutlineHeart } from "react-icons/ai";

export default function Footer() {
  return (
    <footer className="py-4 text-white bg-primary hero-font text-center text-sm md:text-base flex justify-center items-center gap-2">
      <span>Made with</span>
      <AiOutlineHeart className="text-red-400 size-6 animate-pulse" />
      <span>by Priya</span>
    </footer>
  );
}
